import {
  LeftOutlined,
  RightOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { Button, Col, Empty, Input, Popover, Row, Select, Table } from "antd";
import { useContext, useEffect, useState } from "react";
import { Dropdown, Icon } from "semantic-ui-react";
import { BreadCrumbAdmin } from "../../../components/Administrador/Breadcrumb/Breadcrumb";
import { useBancoJurado } from "../../../hooks/useBancoJurado";
import { useMaestras } from "../../../hooks/useMaestras";
import { cantidadRegistros } from "../../../utils/dataSelectOptions";
import { ModalVerMasJurado } from "./ModalVerMasJurado";
import { TemplateContext } from "../../../utils/template_context";
import { ReactComponent as FlechaSelect } from "../../../assets/flecha_select.svg";
import { ReactComponent as IconFlechareg } from "../../../assets/flecha_reg.svg";

export const GestionEvaluador = () => {
  let {
    obtenerJurados,
    jurados,
    loadingJurados,
    handleAreaChange,
    categorias,
    setCategorias,
    filtros,
    setFiltros,
    buscarFiltros,
    limpiarFiltros,
  } = useBancoJurado();

  const context = useContext(TemplateContext);
  const columns: any = [
    {
      title: "No.",
      width: 40,
      render: (datos: any, datos2: any, index: number) => {
        return (
          <>
            <span>{index + 1}</span>
          </>
        );
      },
      fixed: context.device === "lg" ? "left" : false,
    },

    {
      title: "Nombre y apellidos",
      //width: 200,
      render: (datos: any) => {
        return (
          <>
            {datos.primer_nombre} {datos.segundo_nombre} {datos.primer_apellido}
            {datos.segundo_apellido}
          </>
        );
      },
      fixed: context.device === "lg" ? "left" : false,
    },
    {
      title: "Código",
      //width: 120,
      dataIndex: "radicado",
      key: "radicado",
    },
    {
      title: "Estado",
      //width: 120,
      render: (datos: any) => {
        return <div>{datos.status}</div>;
      },
    },
    {
      title: "Área",
      width: 169,
      render: (datos: any) => {
        return <div>{datos.area != null ? datos.area : 'Este jurado no tiene areas'}</div>
      },
    },
    {
      title: "Categorías",
      //width: 169,
      render: (datos: any) => {
        const content = (
          <ul>
            {datos?.areas_conocimientos?.map((conocimientos: any) =>
              conocimientos.areas_conocimientos?.map(
                (datos_conocimientos: any,i) => (
                  <li key={i} className="font-family-Monserrat-Regular font-size-11px"> {datos_conocimientos?.nombre} </li>

                )
              )
            )}

          </ul>
        );



        return (
          <>{/*
            <Popover content={content} title="Categorías">
              {datos?.areas_conocimientos[0]?.areas_conocimientos[0]?.nombre.length > 27 ? `${datos?.areas_conocimientos[0]?.areas_conocimientos[0]?.nombre.substring(0, 24)}...` : `${datos?.areas_conocimientos[0]?.areas_conocimientos[0]?.nombre}...`}
            </Popover>
            */}

          </>
        );
      },
    },

    {
      title: () => (
        <Row className="width-100">
          <Col span={24} className="justify-content-center">
            Acciones
          </Col>
        </Row>
      ),
      //width: 90,
      fixed: context.device === "lg" ? "right" : false,
      render: (datos: any) => (
        <Row justify="center">
          <Col>
            <a
              className="button-azul-ghost"
              onClick={() => openModalVerMas(datos)}
            >
              Ver más
            </a>
          </Col>
        </Row>
      ),
    },
  ];

  const { obtenerAreas, areas } = useMaestras();

  useEffect(() => {
    if (filtros.area === null) {
      setCategorias([]);
    }
  }, [filtros.area]);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      obtenerJurados("gestionEvaluador");
      obtenerAreas();
    }
    return () => {
      mounted = false;
    };
  }, []);

  const routes = [{ nombre: "Postulaciones" }, { nombre: "Gestión evaluador" }];

  const itemRenderTable = (current: any, type: any, originalElement: any) => {
    if (type === "prev") {
      return (
        <span className="border-ant-prev-table font-size-10px">
          <LeftOutlined
            className="font-color-051923bf"
            style={{ display: "inline-flex", paddingRight: "2px" }}
          />
          Ant.
        </span>
      );
    }
    if (type === "next") {
      return (
        <span className="border-ant-prev-table font-size-10px">
          Sig.
          <RightOutlined
            className="font-color-051923bf"
            style={{ display: "inline-flex", paddingLeft: "2px" }}
          />
        </span>
      );
    }
    return originalElement;
  };

  const [idJurado, setIdJurado] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [radicado, setRadicado] = useState("");
  const [idPostulacion, setIdPostulacion] = useState(0);
  const [observacion, setObservacion] = useState();
  const [areaPrincipal, setAreaPrincipal] = useState("");
  const openModalVerMas = (jurado: any) => {
    setAreaPrincipal(jurado.areas_conocimientos[0].area_principal);
    setIdJurado(jurado.id_jurado);
    setOpenModal(true);
    setRadicado(jurado.radicado);
    setIdPostulacion(jurado.id_postulacion);
    setObservacion(jurado.observacion);
  };

  return (
    <>
      <div className="background-color-F7FBFF h-100">
        <BreadCrumbAdmin routes={routes} />
        <div className="container-fluid ps-md-4 pe-md-4 main-c2">
          <div className="title_out_card font-family-Montserrat-SemiBold font-size-14px">
            Gestión evaluador
          </div>

          <div className="sombra_card" style={{ marginBottom: "20px" }}>
            <div>
              <div className="header_card">
                <div className="title_in_card font-size-14px font-color-1B1C1D font-family-Montserrat-Regular">
                  Filtrar jurados
                </div>
              </div>
              <div className="body_card">
                <div className="row">
                  <div className="col-12 col-md-6 col-lg-3 mb-3">
                    <div>
                      <div className="col-12">
                      <label className="font-color-4B4B4B font-family-Montserrat-SemiBold font-size-12px pb-2">Filtrar por palabra clave</label>
                      </div>
                      <div className="col-12">
                        <Input
                          value={filtros.palabra_clave}
                          onChange={(e) =>
                            setFiltros({
                              ...filtros,
                              palabra_clave: e.target.value,
                            })
                          }
                          placeholder="Buscar..."
                          suffix={
                            <SearchOutlined className="font-color-051923bf" />
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-lg-3 mb-3">
                    <div className="row">
                      <div>
                      <label className="font-color-4B4B4B font-family-Montserrat-SemiBold font-size-12px pb-2">Filtrar área</label>
                      </div>
                      <div>
                        <Select
                          suffixIcon={<FlechaSelect />}
                          size="large"
                          value={filtros.area}
                          style={{ width: "100%" }}
                          placeholder="Seleccionar..."
                          onChange={handleAreaChange}
                        >
                          {areas.map(({ id, nombre }: any) => (
                            <Select.Option key={id} value={`${id}.${nombre}`}>
                              {nombre}
                            </Select.Option>
                          ))}
                        </Select>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-lg-3 mb-3">
                    <div className="row">
                      <div>
                      <label className="font-color-4B4B4B font-family-Montserrat-SemiBold font-size-12px pb-2">Filtrar categoría</label>
                      </div>
                      <div>
                        <Select
                          suffixIcon={<FlechaSelect />}
                          size="large"
                          value={filtros.categoria}
                          style={{ width: "100%" }}
                          placeholder="Seleccionar..."
                          onChange={(v) =>
                            setFiltros({ ...filtros, categoria: v })
                          }
                        >
                          {categorias.map(({ id, nombre }: any) => (
                            <Select.Option key={id} value={id}>
                              {nombre}
                            </Select.Option>
                          ))}
                        </Select>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-lg-3 mb-3">
                    <div className="row">
                      <div className="col-12">
                      <label className="font-color-4B4B4B font-family-Montserrat-SemiBold font-size-12px pb-2">Filtrar estado</label>
                      </div>
                      <div className="col-12">
                        <Select
                          suffixIcon={<FlechaSelect />}
                          size="large"
                          value={filtros.estado}
                          style={{ width: "100%" }}
                          placeholder="Seleccionar..."
                          onChange={(e) =>
                            setFiltros({ ...filtros, estado: e })
                          }
                        >
                          <Select.Option value="Postulado">
                            Postulado
                          </Select.Option>
                          <Select.Option value="No cumple">
                            No cumple
                          </Select.Option>
                          <Select.Option value="Sin verificar">
                            Sin verificar
                          </Select.Option>
                        </Select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="footer_card justify-content-flex-end">
                <Button
                  className="button-azul-ghost m-0"
                  onClick={() => limpiarFiltros('gestionEvaluador')}
                >
                  Limpiar filtros
                </Button>
                <Button
                  className="button-azul-radius m-0"
                  onClick={buscarFiltros}
                >
                  Buscar
                </Button>
              </div>
            </div>
          </div>

          <div
            className="row-shadow"
            style={{ marginBottom: "6%", marginTop: "16px" }}
          >
            <div className="col-12">
              <div className="row">
                <div
                  className="col-12 col-md-6 justify-content-flex-start  order-0 font-size-14px font-family-Montserrat-Regular"
                  style={{ paddingBottom: "0%" }}
                >
                  Lista de jurados (Revisar)
                </div>
                <div className="col-12 col-md-6 d-flex justify-content-md-end justify-content-between align-content-center align-items-center mb-3">
                  <div className="d-flex justify-content-end">
                    <div /* span={21} */ /* className="justify-content-center" */
                    >
                      Total: <span className="font-color-F28C02">1</span>
                    </div>
                  </div>
                  <div
                    className="d-flex justify-content-end registos-adminconvocatoria"
                    style={{ width: 200 }}
                  >
                    <label className="font-family-Montserrat-Regular  font-size-9px font-color-7E7E7E pe-2 d-flex justify-content-end">
                      Registros por página
                    </label>
                    <Dropdown
                      className="select-registros-adminconvocatoria no-margin justify-content-center d-flex"
                      // defaultValue={cantidadPaginas}
                      options={cantidadRegistros}
                      icon={<IconFlechareg/>
                    }
                    // onChange={(e, { value }) => cambiarCantidadPaginas(e, value)}
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-12">
                  <Table
                    style={{ borderTop: "1px solid #C4C4C4" }}
                    locale={{
                      emptyText: (
                        <Empty
                          description="No se han diligenciados datos para está sección"
                          style={{ padding: "50px" }}
                        />
                      ),
                    }}
                    pagination={{
                      position: ["bottomRight"],
                      itemRender: itemRenderTable,
                      pageSize: 10,
                    }}
                    dataSource={jurados}
                    columns={columns}
                    size="small"
                    bordered={false}
                    loading={loadingJurados}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {openModal && (
        <ModalVerMasJurado
          openModal={openModal}
          setOpenModal={setOpenModal}
          idJurado={idJurado}
          radicado={radicado}
          id_postulacion={idPostulacion}
          tipoPostulacion={"gestionEvaluador"}
          obtenerJurados={obtenerJurados}
          areaPrincipal={areaPrincipal}
        />
      )}
    </>
  );
};
